import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CSelect from '@/components/CForm/CSelect'
import CRadio from '@/components/CForm/CRadio'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData, tableData1, tableData2, tableData3} from './data'
import './index.scss'
import { getPftjHandler } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.getListData();
  }


  state = {
    columns: tableData.tHead,
    columns1: tableData1.tHead,
    columns2: tableData2.tHead,
    columns3: tableData3.tHead,
    dataSource: tableData.tBody,
    dataSource1: tableData1.tBody,
    dataSource2: tableData2.tBody,
    dataSource3: tableData3.tBody,
    loading: true,
    annual: '',
    levelid: '',
    ownerlist:[],
    options:[
      {
        "name": "全部",
        "id": '',
        "value": "",
      },
      {
        "name": "一级",
        "id": "1410",
        "value": "1410",
      },
      {
        "name": "二级",
        "id": "1411",
        "value": "1411",
      },
      {
        "name": "三级",
        "id": "1412",
        "value": "1412",
      }
    ],
  };

  onChange(name,data){
    this.setState({
      [name]:data
    },()=>{
      this.getListData()
    })
  }

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    const params = {
      annual:this.state.annual,
    }
    getPftjHandler(params).then(res=>{
      let data =JSON.parse(JSON.stringify(res.records))
      this.setState({
        dataSource: data,
        loading: false
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  componentWillMount(){

  }

  componentDidMount(){
    const yearrange = JSON.parse(localStorage.getItem('userInfo'))[0].sysidlist
    const arr = []
    yearrange.forEach(item=>{
      let obj = {}
      obj.name = item
      obj.id = item
      obj.value = item
      arr.push(obj)
    })
    this.setState({
      ownerlist:arr,
      annual:arr[0].id,
    },()=>{
      this.getListData();
    })
  }
  render(){
    return (
        <div className='user-manage-list'>
          <div className='flex filter-wrap'>
            <div className='filter-left' style={{width: '100%',display:'flex',flexWrap:'wrap',alignItems:'center',marginBottom:'20px'}}>
              <div style={{width:'250px',marginTop:'-10px'}}>
                <label htmlFor="" >
                  评估年度：</label>
                <CSelect
                    value={this.state.annual}
                    options={this.state.ownerlist}
                    placeholder='请选择评估年度'
                    onChange={(e)=>{this.onChange('annual',e)}}
                    style={{width: '100px'}}
                />
              </div>
            </div>
          </div>
          {this.state.dataSource.map((item,index)=>{
            return(
                <div>
                  {index === 0?
                      <h2>{item.title}</h2>:
                      <h2 style={{marginTop:'50px'}}>{item.title}</h2>
                  }
                  {
                    item.datalist.map((item,index1)=>{
                      return (<div style={{display:'flex',borderBottom:'1px solid #bebebe',marginTop:'20px'}}>
                        {
                          item.map(item2=>{
                            return (
                                <div style={{flex:1,textAlign:'center',marginBottom:'10px',alignItems:'center'}}>{item2}</div>
                            )
                          })
                        }
                      </div>)
                    })
                  }
                </div>
            )
          })}
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
